export default {
  test: 'huobi test',
};


// WEBPACK FOOTER //
// ./src/locales/zh-CN/test.ts